module.exports = __webpack_public_path__ + "static/media/Error.ed2bfcd8.svg";